define(['text!./templates/basler-loading-template.html'], (templateStr) => {

    /**
     * Displays little loading indicator beside pl-ctrl-group element (near help button)
     */

    return ['$rootScope', 'CallTrackerService', function ($rootScope, CallTrackerService) {
            return {
                restrict: 'A',
                scope: {
                    callGroup: '@',
                },
                template: templateStr,
                link: function (scope) {
                    scope.display = false;

                    $rootScope.$watch('callTrackerCounter', () => {
                        scope.display = CallTrackerService.anyInFlightCall(scope.callGroup);
                    });
                },
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerLoadingIndicatorDirective.js